import { createFileRoute } from '@tanstack/react-router';
import { Container, Grid } from '@mui/material';
import { useSuspenseQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { managerDocument } from '@social-garden/api/documents/manager.ts';
import PageTitle from '@/components/PageTitle.tsx';
import UpdatePassword from '@/components/Settings/UpdatePassword.tsx';
import RequestNewEmail from '@/components/Settings/RequestNewEmail.tsx';
import DeleteAccount from '@/components/Settings/DeleteAccount.tsx';
import GeneralSettings from '@/components/Settings/GeneralSettings.tsx';

export const Route = createFileRoute('/_manager/settings')({
  component: Settings,
});

function Settings() {
  const { t } = useTranslation(['manager']);
  const { data } = useSuspenseQuery(managerDocument);

  if (data.whoAmI.__typename !== 'ManagerAuthenticatable') {
    throw new Error('Authenticated user is not a manager!');
  }

  return (
    <Container>
      <Grid container spacing={4}>
        <Grid size={12}>
          <PageTitle>{t('manager:settings.title')}</PageTitle>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}>
          <GeneralSettings />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}>
          <RequestNewEmail currentEmail={data.whoAmI.user.email} />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}>
          <UpdatePassword />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}>
          <DeleteAccount />
        </Grid>
      </Grid>
    </Container>
  );
}
